import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import '../Style/LedgerDesign.css';
import { BASE_URL } from "../Apis/apiConfig";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CurrentlyYearLedger = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [ledgers, setLedgerData] = useState([]);
  const [error, setError] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ PAGINATION STATE ADDED
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    fetchLedgerData();
  }, []);

  const normalizeUnit = (value) => {
    if (!value) return "";
    let v = value.toUpperCase().replace(/\s+/g, "");
    const match = v.match(/^([A-Z]+)(\d+)$/);
    if (match) {
      return `${match[1]}-${match[2]}`;
    }
    return v;
  };

  const filteredLedgers = ledgers.filter((member) => {
    const search = normalizeUnit(searchTerm);
    const memberUnit = normalizeUnit(member.unit_no);
    const memberName = member.member_name?.toLowerCase();

    return (
      memberName?.includes(searchTerm.toLowerCase()) ||
      memberUnit?.includes(search)
    );
  });

  // ✅ PAGINATION LOGIC ADDED
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredLedgers.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredLedgers.length / rowsPerPage);

  const fetchLedgerData = async () => {
    try {
      const token = localStorage.getItem("token");
      const society = localStorage.getItem("society");

      const response = await axios.get(
        `${BASE_URL}/api/member/get-list`,
        {
          params: { society: society },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      setLedgerData(response.data);

    } catch (err) {
      console.error(err);
      setError("Failed to fetch ledger data");
    }
  };

  const handlePreviousLedgerClick = async (unitNo) => {
    const token = localStorage.getItem("token") ?? "";
    const societyName = localStorage.getItem("society") ?? "";

    try {
      const response = await axios.post(
        `${BASE_URL}/ledger/add-ledger-financial-pervious?wingFlat=${unitNo}&societyName=${societyName}`,
        {},
        {
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      const ledgerData = response.data;

      navigate("/pervious-year-ledger", {
        state: { ledgerData, unitNo },
      });

    } catch (err) {
      console.error("Error fetching previous ledger:", err);
      alert("Failed to fetch previous ledger");
    }
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <div style={{ marginBottom: "15px", display: "flex", gap: "10px", marginTop: "10px" }}>
            <input
              type="text"
              placeholder="Search by Member Name or Unit No (A101, A-101, A)"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); 
              }}
              style={{
                padding: "8px 12px",
                width: "300px",
                borderRadius: "6px",
                border: "1px solid #ccc"
              }}
            />
          </div>

          {filteredLedgers && filteredLedgers.length > 0 && (
            <>
              <div className="ledger-table-wrapper">
                <table className="ledger-table">
                  <thead>
                    <tr style={{ color: "#007BFF" }}>
                      <th>Sr No</th>
                      <th>Member Name</th>
                      <th>Unit No</th>
                      <th>Flat Sq. Ft</th>
                      <th>Status</th>
                      <th>Currently Year</th>
                      <th>Pervious Year</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentRows.map((member, index) => (
                      <tr key={index}>
                        <td>{member.sr_no}</td>
                        <td>{member.member_name}</td>
                        <td>{member.unit_no}</td>
                        <td>{member.flat_square_feet}</td>
                        <td>{member.status}</td>
                        <td>
                          <button
                            className="ledger-btn"
                            onClick={() =>
                              navigate("/financial-ledger", {
                                state: { unitNo: member.unit_no }
                              })
                            }
                          >
                            Currently Year Ledger
                          </button>
                        </td>
                        <td>
                          <button
                            className="ledger-btn"
                            onClick={() => handlePreviousLedgerClick(member.unit_no)}
                          >
                            Previous Year Ledger
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
                gap: "10px"
              }}>
                <button
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="ledger-btn"
                >
                  Previous
                </button>

                <span
                  style={{
                    padding: "6px 12px",
                    fontWeight: "500",
                    color: "#007BFF"
                  }}
                >
                  Page {currentPage} of {totalPages}
                </span>

                <button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(prev + 1, totalPages)
                    )
                  }
                  disabled={currentPage === totalPages}
                  className="ledger-btn"
                >
                  Next
                </button>
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default CurrentlyYearLedger;
